var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "my-info-browsinghistory" }, [
    _c("div", { staticClass: "f-nav" }, [
      _c("div", { class: ["nav", _vm.changeType == "l" ? "active-nav" : ""] }, [
        _c(
          "div",
          {
            staticClass: "nav-block",
            on: {
              click: function ($event) {
                return _vm.change_type("l")
              },
            },
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("div", {
              class: [
                "nav",
                _vm.changeType == "l" ? "change-line-active" : "change-line",
              ],
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          class: ["nav", _vm.changeType == "s" ? "active-nav" : ""],
          on: {
            click: function ($event) {
              return _vm.change_type("s")
            },
          },
        },
        [
          _c("div", { staticClass: "nav-block" }, [
            _c("div", [_vm._v("收藏房源")]),
            _vm._v(" "),
            _c("div", {
              class: [
                "nav",
                _vm.changeType == "s" ? "change-line-active" : "change-line",
              ],
            }),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { ref: "homeCon" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.changeType == "l",
              expression: "changeType == 'l'",
            },
          ],
          staticClass: "wrapper",
        },
        _vm._l(_vm.list, function (house, index) {
          return _c("house-item", {
            key: index,
            attrs: { house: house, type: "2" },
            on: { handleHosue: _vm.handleHosue },
          })
        }),
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.changeType == "l" && _vm.show_selectedType,
            expression: "changeType == 'l' && show_selectedType",
          },
        ],
        staticClass: "browse-menu",
        on: {
          click: function ($event) {
            return _vm.closedChage()
          },
        },
      },
      [
        _c("div", { staticClass: "change-type" }, [
          _c(
            "div",
            {
              class: [
                "tag",
                _vm.liu_selected == "ershoufan" ? "active-tag" : "",
              ],
              on: {
                click: function ($event) {
                  return _vm.selectType("ershoufan")
                },
              },
            },
            [_c("div", [_vm._v("二手房")]), _vm._v(" "), _vm._m(1)]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              class: ["tag", _vm.liu_selected == "zufan" ? "active-tag" : ""],
              on: {
                click: function ($event) {
                  return _vm.selectType("zufan")
                },
              },
            },
            [_c("div", [_vm._v("租房")]), _vm._v(" "), _vm._m(2)]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              class: ["tag", _vm.liu_selected == "xinfan" ? "active-tag" : ""],
              on: {
                click: function ($event) {
                  return _vm.selectType("xinfan")
                },
              },
            },
            [_c("div", [_vm._v("新房")]), _vm._v(" "), _vm._m(3)]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "nav-block-arrow" }, [
      _c("div", [_vm._v("浏览历史")]),
      _vm._v(" "),
      _c("div", { staticClass: "arrow-bottom" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "show-active-tag", staticStyle: { display: "none" } },
      [
        _c("img", {
          staticClass: "selected-icon",
          attrs: { src: require("../../images/icon/selected.png"), alt: "" },
        }),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "show-active-tag", staticStyle: { display: "none" } },
      [
        _c("img", {
          staticClass: "selected-icon",
          attrs: { src: require("../../images/icon/selected.png"), alt: "" },
        }),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "show-active-tag", staticStyle: { display: "none" } },
      [
        _c("img", {
          staticClass: "selected-icon",
          attrs: { src: require("../../images/icon/selected.png"), alt: "" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }